// The legacy API transports this field in ten-thousand yuan, despite its label.
export function formatAssetValuation(value, precision) {
  if (value === null || value === undefined ||
      (typeof value === 'string' && !value.trim()) ||
      (typeof value !== 'number' && typeof value !== 'string')) {
    return '缺失/未核实';
  }
  const billions = Number(value) / 10000;
  if (!Number.isFinite(billions)) return '缺失/未核实';
  const decimals = precision === undefined
    ? (String(Math.trunc(Math.abs(billions))).length >= 2 ? 1 : 2) : precision;
  return billions.toFixed(decimals);
}

export function assetValuationConflictNotice(conflicts) {
  return Array.isArray(conflicts) && conflicts.length
    ? `存在 ${conflicts.length} 处同日估值冲突，空缺区间不代表零估值` : '';
}
